'use strict'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const initLazyLoad = () => {
	const dataElements = document.querySelectorAll('img[data-src], video[data-video]');

	dataElements.forEach(el => {
		// Берём источник: сначала data-src, потом data-video
		const src = el.getAttribute('data-src') || el.getAttribute('data-video');
		if (src) el.setAttribute('src', src);

		// Для картинок ставим srcset
		if (el.tagName.toLowerCase() === 'img') {
			const srcset = el.getAttribute('data-srcset');
			if (srcset) el.setAttribute('srcset', srcset);

			el.onload = () => {
				el.removeAttribute('data-src');
				el.removeAttribute('data-srcset');
			}
		} else if (el.tagName.toLowerCase() === 'video') {
			// Для видео ждём, когда данные загрузятся
			el.onloadeddata = () => {
				el.removeAttribute('data-video');
			}
		}
	});
};

const initInjectSvg = () => {
	var mySVGs = document.querySelectorAll('.svgItems');

	SVGInjector(mySVGs, {
		evalScripts: 'once',
	});
}
const getVwScrollBar = () => {
	const scrollbarPx = window.innerWidth - document.documentElement.clientWidth;
	document.documentElement.style.setProperty('--scrollbar-px', `${scrollbarPx}px`);
}

getVwScrollBar()

initInjectSvg()
initLazyLoad()


const showSubmitBlock = () => {

	const contactBlock = document.querySelector('.contact-block');

	if (contactBlock) {
		const activeElement = document.querySelector('.contact-block__el.active');
		const successBlock = activeElement.querySelector('.success-form')
		activeElement.classList.add('success-open');
		successBlock.classList.add('active');
		ScrollTrigger?.refresh();
	} else {
		const successBlock = document.querySelector('.success-form');
		if (successBlock) {
			successBlock.parentElement.classList.add('success-open');
			successBlock.classList.add('active');
			ScrollTrigger?.refresh();
		}
	}

}

const hideSubmitBlock = () => {

	const contactBlock = document.querySelector('.contact-block');

	if (contactBlock) {
		const activeElement = document.querySelector('.contact-block__el.active');
		const successBlock = activeElement.querySelector('.success-form')
		activeElement.classList.remove('success-open');
		successBlock.classList.remove('active');
		ScrollTrigger?.refresh();
	} else {
		const successBlock = document.querySelector('.success-form');
		if (successBlock) {
			successBlock.parentElement.classList.remove('success-open');
			successBlock.classList.remove('active');
			ScrollTrigger?.refresh();
		}
	}
}

const showPopupMain = () => {
	const popupMain = document.querySelector('.popup-main');
	if (popupMain) {
		document.body.classList.add('no-scroll');
		popupMain.classList.add('active');
	}
}
const hidePopupMain = () => {
	const popupMain = document.querySelector('.popup-main');
	if (popupMain) {
		document.body.classList.remove('no-scroll');
		popupMain.classList.remove('active');
		popupMain.classList.remove('success');
	}
}

const showSuccessMessagePopup = () => {
	const popupMain = document.querySelector('.popup-main');
	if (popupMain) {
		popupMain.classList.add('success');
	}
}
const hideSuccessMessagePopup = () => {
	const popupMain = document.querySelector('.popup-main');
	if (popupMain) {
		popupMain.classList.remove('success');
		document.body.classList.remove('no-scroll');
	}
}

const hidePopupOutsideClickMain = () => {
	const popupBg = document.querySelectorAll(".popup-main-bg");

	if (!popupBg.length) return;

	popupBg.forEach((el) => {
		el.addEventListener('click', e => {
			if (e.target === el) {
				hidePopupMain();
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', () => {
	/*const animateHeader = () => {
		const header = document.querySelector('header');
		const sections = document.querySelectorAll('[data-header]');

		const updateHeaderTheme = (init) => {
			let currentTheme = null;
			const offset = 50;

			sections.forEach(section => {
				const rect = section.getBoundingClientRect();

				if ((rect.top <= offset && rect.bottom > offset) || (init && rect.top === 0)) {
					currentTheme = section.dataset.header;
				}
			});
			header.classList.remove('light', 'dark', 'normal');

			if (currentTheme === 'light') {
				header.classList.add('light');
			} else if (currentTheme === 'dark') {
				header.classList.add('dark');
			} else if (currentTheme === 'normal') {
				header.classList.add('normal');
			}
		};

		updateHeaderTheme(true);

		ScrollTrigger.create({
			start: 0,
			onUpdate: self => {
				updateHeaderTheme(false);
			}
		});
	};*/
	const animateHeader = () => {
		const header = document.querySelector('header');
		const sections = document.querySelectorAll('[data-header]');
	  
		const setHeaderTheme = (theme) => {
		  	header.classList.remove('light', 'dark', 'normal');
		  	if (theme) header.classList.add(theme);
		};
	  
		sections.forEach(section => {
		  	ScrollTrigger.create({
				trigger: section,
				start: 'top 50px',
				end: 'bottom 50px',
				onEnter: () => setHeaderTheme(section.dataset.header),
				onEnterBack: () => setHeaderTheme(section.dataset.header),
		  	});
		});

		ScrollTrigger?.refresh();
	};
	const animateHeaderMenu = () => {
		const menuItems = document.querySelectorAll('.header-menu__item.has-children');

		menuItems.forEach(item => {
			const link = item.querySelector('.header-menu__link');
			const submenu = item.querySelector('.header-menu__level2');

			if (link && submenu) {
				link.addEventListener('click', function (e) {
					e.preventDefault();
					const isActive = item.classList.contains('active');

					menuItems.forEach(i => {
						i.classList.remove('active');
						const sub = i.querySelector('.header-menu__level2');
						if (sub) sub.style.maxHeight = null;
					});

					if (!isActive) {
						item.classList.add('active');
						submenu.style.maxHeight = submenu.scrollHeight + 'px';
					}
				});

				if (item.classList.contains('active')) {
					submenu.style.maxHeight = submenu.scrollHeight + 'px';
				}
			}
		});

		const headerClose = document.querySelector('.header-menu__close');
		const headerOpen = document.querySelector('.header__burger');
		const headerMenu = document.querySelector('.header-menu');
		const header = document.querySelector('.header');
		headerClose.addEventListener('click', e => {
			e.preventDefault();
			headerMenu.classList.toggle('active');
			document.body.classList.remove('no-scroll');

		})
		headerOpen.addEventListener('click', e => {
			e.preventDefault();
			headerMenu.classList.toggle('active');
			document.body.classList.add('no-scroll');
		})

		const dropLinks = document.querySelectorAll('.header__link.has-drop');

		dropLinks.forEach(link => {
			link.addEventListener('mouseenter', () => {
				dropLinks.forEach(l => l.classList.remove('is-open'));
				link.classList.add('is-open');
				header.classList.add('white');
			});

			link.addEventListener('mouseleave', () => {
				link.classList.remove('is-open');
				header.classList.remove('white');
			});
		});

		window.addEventListener('scroll', () => {
			dropLinks.forEach(link => link.classList.remove('is-open'));
			header.classList.remove('white');

		});

		document.addEventListener('click', (e) => {
			if (![...dropLinks].some(link => link.contains(e.target))) {
				dropLinks.forEach(link => link.classList.remove('is-open'));
				header.classList.remove('white');
			}
		});
	}

	const loadSplineScript = (callback) => {
		const container = document.getElementById('spline-script');
		if (!container) return;

		const url = container.dataset.splineUrl;
		if (!url) return;

		// Если скрипт уже есть — сразу вызываем callback
		if (document.querySelector(`script[src="${url}"]`)) {
			callback();
			return;
		}


		// Создаём и подключаем скрипт
		const script = document.createElement('script');
		script.src = url;
		script.onload = callback;
		document.body.appendChild(script);
	};

	function initSplineWithFallback(containerSelector) {
		const container = document.querySelector(containerSelector);
		if (!container) return;

		let splineInstance = null;
		let videoFallback = null;
		let observer = null;
		let isMobileState = window.innerWidth < 768;

		const isMobile = () => window.innerWidth < 768;

		const loadSpline = () => {
			if (splineInstance) return;
			if (!container.offsetWidth || !container.offsetHeight) return;

			if (videoFallback) {
				videoFallback.remove();
				videoFallback = null;
			}

			const spline = document.createElement('spline-viewer');
			spline.setAttribute('url', container.dataset.url);
			spline.style.width = '100%';
			spline.style.height = '100%';
			container.appendChild(spline);
			splineInstance = spline;
		};

		const unloadSpline = () => {
			if (splineInstance) {
				if (splineInstance.destroy) splineInstance.destroy();
				splineInstance.remove();
				splineInstance = null;
			}
		};

		const loadFallback = () => {
			if (videoFallback) {
				videoFallback.remove();
			}
			unloadSpline();

			const video = document.createElement('video');
			video.src = container.dataset.video;
			video.autoplay = true;
			video.loop = true;
			video.muted = true;
			// video.controls = true;
			video.playsInline = true;
			video.style.width = '100%';
			video.style.height = '100%';
			video.style.objectFit = 'cover';

			const tryPlay = () => {
				video.play().catch(() => {
					video.src = container.dataset.video + '?t=' + Date.now();
					video.load();
					container.style.css.display = 'none';
					setTimeout(tryPlay, 200);
				});
			};

			// Сначала скрываем постер, когда видео готово к воспроизведению
			video.addEventListener('canplay', () => {
				const poster = container.querySelector('.spline-video-poster');
				if (poster) poster.style.display = 'none';
				video.style.display = 'block';
				tryPlay();

			});

			container.appendChild(video);
			videoFallback = video;
		};


		const isInViewport = (el) => {
			const rect = el.getBoundingClientRect();
			return rect.top < window.innerHeight && rect.bottom > 0;
		};

		const init = () => {
			const mobileNow = isMobile();

			// Если сменился breakpoint
			if (mobileNow !== isMobileState) {
				isMobileState = mobileNow;
				unloadSpline();
				if (videoFallback) {
					videoFallback.remove();
					videoFallback = null;
				}
			}

			if (mobileNow) {
				loadFallback();
			} else {
				if (isInViewport(container)) {
					loadSplineScript(() => loadSpline());
				} else if (!observer) {
					observer = new IntersectionObserver((entries, obs) => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								loadSplineScript(() => loadSpline());
								obs.unobserve(container);
							}
						});
					}, {threshold: 0.1});
					observer.observe(container);
				}
			}
		};

		let resizeTimeout;

		window.addEventListener('resize', () => {
			const currentWidth = window.innerWidth;
			const currentDPR = window.devicePixelRatio;

			if (currentWidth !== previousWidth) {
				if (currentWidth >= 1024) {
					resizeTimeout = setTimeout(init, 200);

				}
				if (currentWidth <= 1023 && currentDPR === previousDPR) {
					resizeTimeout = setTimeout(init, 200);
				}

				previousWidth = currentWidth;
				previousDPR = currentDPR;
			}
		});

		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible' && isMobile()) {
				loadFallback()
			}
		});
		init();
	}

	function initSpline(containerSelector) {
		const container = document.querySelector(containerSelector);
		if (!container) return;

		let splineInstance = null;

		const loadSpline = () => {

			const spline = document.createElement('spline-viewer');
			spline.setAttribute('url', container.dataset.url);
			spline.style.width = '100%';
			spline.style.height = '100%';
			container.appendChild(spline);
			splineInstance = spline;
		};
		loadSplineScript(() => loadSpline());
	}

	const animateAboutHomeFunc = () => {
		const ACCORDION_SELECTOR = '.about-home__accordion';
		const ITEM_SELECTOR = '.about-home__item';
		const LINE_SELECTOR = '.about-home__progress';
		const NAME_SELECTOR = '.about-home__name';

		const accordion = document.querySelector(ACCORDION_SELECTOR);
		if (!accordion) return;

		const INTERVAL = parseInt(accordion.getAttribute('data-speed')) || 0;

		const items = Array.from(accordion.querySelectorAll(ITEM_SELECTOR));
		let currentIndex = items.findIndex(item => item.classList.contains('active'));
		if (currentIndex === -1) currentIndex = 0;

		let intervalId = null;
		let gsapTweens = [];

		function resetItems() {
			gsapTweens.forEach(tween => tween.kill());
			gsapTweens = [];

			items.forEach((item, i) => {
				const content = item.querySelector('.about-home__content');
				if (i === currentIndex) {
					item.classList.add('active');
					content.style.maxHeight = content.scrollHeight + 'px';
				} else {
					item.classList.remove('active');
					content.style.maxHeight = null;
				}
				const line = item.querySelector(LINE_SELECTOR);
				if (line) {
					gsap.set(line, {width: INTERVAL > 0 ? '0%' : '100%'});
				}
			});
		}

		function animateProgress(line) {
			if (!line) return;

			gsapTweens.forEach(tween => tween.kill());
			gsapTweens = [];

			if (INTERVAL <= 0) {
				gsap.set(line, {width: '100%'});
				return;
			}

			gsap.set(line, {width: '0%'});
			const tween = gsap.to(line, {
				width: '100%',
				duration: INTERVAL,
				ease: 'linear'
			});
			gsapTweens.push(tween);
		}

		function openItem(index) {
			if (index < 0 || index >= items.length) return;
			if (index === currentIndex) return;

			const prevItem = items[currentIndex];
			const prevContent = prevItem.querySelector('.about-home__content');
			if (prevContent) prevContent.style.maxHeight = null;
			prevItem.classList.remove('active');

			const prevLine = prevItem.querySelector(LINE_SELECTOR);
			if (prevLine) gsap.set(prevLine, {width: INTERVAL > 0 ? '0%' : '100%'});

			const newItem = items[index];
			const newContent = newItem.querySelector('.about-home__content');
			if (newContent) newContent.style.maxHeight = newContent.scrollHeight + 'px';
			newItem.classList.add('active');

			const line = newItem.querySelector(LINE_SELECTOR);
			animateProgress(line);

			currentIndex = index;
		}

		function startAutoSwitch() {
			if (INTERVAL <= 0) return; // не запускаем автосмену
			if (intervalId) clearInterval(intervalId);

			intervalId = setInterval(() => {
				const nextIndex = (currentIndex + 1) % items.length;
				openItem(nextIndex);
			}, INTERVAL);
		}

		resetItems();

		const firstLine = items[currentIndex].querySelector(LINE_SELECTOR);
		animateProgress(firstLine);

		startAutoSwitch();

		items.forEach((item, i) => {
			const name = item.querySelector(NAME_SELECTOR);
			if (!name) return;
			name.style.cursor = 'pointer';

			name.addEventListener('click', () => {
				if (i === currentIndex) return;
				openItem(i);
				startAutoSwitch();
			});
		});
	};

	const animateFirstAboutHomeItemOnly = () => {
		const ACCORDION_SELECTOR = '.about-home__accordion';
		const ITEM_SELECTOR = '.about-home__item';
		const LINE_SELECTOR = '.about-home__progress';

		const accordion = document.querySelector(ACCORDION_SELECTOR);
		if (!accordion) return;

		const items = Array.from(accordion.querySelectorAll(ITEM_SELECTOR));
		if (items.length === 0) return;

		items.forEach(item => {
			item.classList.remove('active');
			const content = item.querySelector('.about-home__content');
			if (content) content.style.maxHeight = null;
			const line = item.querySelector(LINE_SELECTOR);
			if (line) gsap.set(line, {width: '0%'});
		});

		const firstItem = items[0];
		firstItem.classList.add('active');
		const content = firstItem.querySelector('.about-home__content');
		if (content) content.style.maxHeight = content.scrollHeight + 'px';
	};

	const initAboutHomeAnimationOnScroll = () => {
		const about = document.querySelector('.about-home');
		if (!about) return;

		let hasStarted = false;

		ScrollTrigger.create({
			trigger: about,
			start: "top 80%",
			once: true,
			id: "triggerHome",
			onEnter: () => {
				if (!hasStarted) {
					animateAboutHomeFunc();
					hasStarted = true;
				}
			}
		});
	};

	const initHeroHomeAnimation = () => {
		let mm = gsap.matchMedia();

		const intro = document.querySelector('.intro-home');
		const about = document.querySelector('.about-home');
		const aboutImage = document.querySelector('.about-home__faq-image img');
		const aboutTrigger = document.querySelector('.about-home__faq-image');

		if (!intro || !about) return;


		mm.add("(min-width: 1024px)", () => {
			if (aboutImage) {
				gsap.to(aboutImage, {
					yPercent: -10,
					scale: 1.2,
					ease: "none",
					scrollTrigger: {
						trigger: aboutTrigger,
						start: "bottom bottom",
						end: "top top",
						scrub: true
					}
				});
			}


			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: intro,
					start: "bottom bottom",
					scrub: true,
					pin: true,
					pinSpacing: false,
					anticipatePin: 1
				}
			});

			tl.to(about, {
				y: 0,
				ease: "none"
			});

			return () => {
				tl.scrollTrigger?.kill();
				tl.kill();
			};
		});
	};

	const initLogoAnimation = () => {
		const duration = 25
		const animateTracks = (trackPairs) => {
			trackPairs.forEach(([leftSelector, rightSelector]) => {
				const leftTrack = document.querySelector(leftSelector);
				const rightTrack = document.querySelector(rightSelector);

				if (leftTrack) {
					gsap.killTweensOf(leftTrack);
					const leftWidth = leftTrack.scrollWidth / 3;

					gsap.fromTo(leftTrack,
						{x: 0},
						{
							x: `-=${leftWidth}`,
							duration: duration,
							ease: 'linear',
							repeat: -1
						}
					);
				}

				if (rightTrack) {
					gsap.killTweensOf(rightTrack);
					const rightWidth = rightTrack.scrollWidth / 3;

					gsap.fromTo(rightTrack,
						{x: `-${rightWidth}`},
						{
							x: 0,
							duration: duration,
							ease: 'linear',
							repeat: -1
						}
					);
				}
			});
		};

		const animateLogosResponsive = () => {
			const trackPairs = [
				['.intro-home__logos-track.left', '.intro-home__logos-track.right'],
				['.why-block__logos-track.left', '.why-block__logos-track.right'],
				['.contact-block__logos-track.left', null],
			];

			animateTracks(trackPairs);
		};


		animateLogosResponsive();
	};

	const initFaqAnimation = () => {
		const faqItems = document.querySelectorAll('.faq-block__item');

		if (!faqItems?.length) return;

		const recalcActiveItemHeight = () => {
			const activeItem = document.querySelector('.faq-block__item.active');
			if (activeItem) {
				const description = activeItem.querySelector('.faq-block__description');
				description.style.maxHeight = description.scrollHeight + 'px';
			}
		};

		faqItems.forEach(item => {
			const description = item.querySelector('.faq-block__description');

			if (item.classList.contains('active')) {
				description.style.maxHeight = description.scrollHeight + 'px';
				description.style.opacity = '1';
			}

			item.addEventListener('click', function () {
				const isActive = item.classList.contains('active');

				faqItems.forEach(el => {
					el.classList.remove('active');
					const desc = el.querySelector('.faq-block__description');
					desc.style.maxHeight = null;
					desc.style.opacity = '0';
				});

				if (!isActive) {
					item.classList.add('active');
					description.style.maxHeight = description.scrollHeight + 'px';
					description.style.opacity = '1';
				}
			});
		});

		window.addEventListener('resize', recalcActiveItemHeight);
	};

	function scrollToDuration(target, duration = 200, callback) {
		const start = window.pageYOffset || document.documentElement.scrollTop;
		const distance = target - start;
		const startTime = performance.now();

		function step(now) {
			const elapsed = now - startTime;
			const progress = Math.min(elapsed / duration, 1);

			// easeInOutQuad
			const eased = progress < 0.5
				? 2 * progress * progress
				: -1 + (4 - 2 * progress) * progress;

			const current = start + distance * eased;
			window.scrollTo(0, current);

			if (progress < 1) {
				requestAnimationFrame(step);
			} else if (callback) {
				callback();
			}
		}

		requestAnimationFrame(step);
	}

	const animSvgLeverage = () => {
		const path = document.getElementById("motionPath");
		const g = document.getElementById("movingGroup");
		const tooltip = document.querySelector(".leverage-home__tooltip");
		const tooltipText = tooltip?.querySelector(".leverage-home__tooltip-content");
		const groups = document.querySelectorAll(".leverage-home__svg g.line-svg");

		if (!path || !g || groups.length === 0) return;

		const totalLength = path.getTotalLength();
		const centerLength = totalLength / 1.57;
		const offset = {x: 72, y: 88};
		const state = {progress: 0};
		let isAnimEnd = false
		const updateG = (pos) => {
			const clamped = Math.min(Math.max(pos, 10), totalLength);
			const pt = path.getPointAtLength(clamped);
			g.setAttribute("transform", `translate(${pt.x - offset.x}, ${pt.y - offset.y})`);
			state.progress = clamped;
		};

		const updateTooltip = (text, line, circle, group) => {
			if (text && tooltip && tooltipText) {
				tooltipText.innerHTML = text;
				const rectCircle = circle.getBoundingClientRect();
				const rectLine = line.getBoundingClientRect();
				const rectWrapper = group?.closest('.leverage-home__wrapper').getBoundingClientRect();
				const tooltipX = rectCircle.left - rectWrapper.left + rectCircle.width / 2 - tooltip.offsetWidth / 2;
				const tooltipY = rectLine.top - rectWrapper.top + rectLine.height / 2 - tooltip.offsetHeight / 2;

				tooltip.style.left = `${tooltipX}px`;
				tooltip.style.top = `${tooltipY}px`;
				tooltip.classList.add("active");
			}
		};

		const hideTooltip = () => {
			tooltip.classList.remove("active");
			tooltipText.innerHTML = '';
		};

		const moveTo = (target) => {
			gsap.killTweensOf(state);
			const distance = Math.abs(target - state.progress);
			if (distance === 0) return;

			const speed = 300;
			const duration = distance / speed;

			gsap.to(state, {
				progress: target,
				duration: duration,
				ease: "power1.inOut",
				onUpdate: () => updateG(state.progress)
			});
		};

		const changeLineAndCircle = (line, circle, color, width, addDot = true) => {
			line.setAttribute("stroke", color);
			line.setAttribute("stroke-width", width);
			if (addDot) {
				circle.classList.add('active-dot');
			} else {
				circle.classList.remove('active-dot');
			}
		};

		const handleLineAnimation = (line, circle, text, group, targetProgress) => {
			changeLineAndCircle(line, circle, "#626BF7", "2");

			updateTooltip(text, line, circle, group);

			setTimeout(() => {
				changeLineAndCircle(line, circle, '#272A34', '2', false);
				hideTooltip();

				if (isAnimEnd) return
				moveTo(targetProgress);
			}, 2000);
		};

		const findClosestLength = (x, y, samples = 500) => {
			let best = 0, minDist = Infinity;
			for (let i = 0; i <= samples; i++) {
				const len = (i / samples) * totalLength;
				const pt = path.getPointAtLength(len);
				const dist = (pt.x - x) ** 2 + (pt.y - y) ** 2;
				if (dist < minDist) {
					minDist = dist;
					best = len;
				}
			}
			return best;
		};

		const firstEl = document.querySelector('.leverage-home__svg .first-line');
		const lineFirst = firstEl.querySelector("line");
		const elevEl = document.querySelector('.leverage-home__svg .th-line');
		const lineEvel = elevEl.querySelector("line");


		groups.forEach(group => {
			const line = group.querySelector("line");
			const circle = group.querySelector(".movingCircle");
			if (!line || !circle) return;

			line.dataset.prevStroke = line.getAttribute("stroke") || "#FF4142";
			line.dataset.prevStrokeWidth = line.getAttribute("stroke-width") || "1";

			group.addEventListener("mouseenter", () => {
				lineFirst.setAttribute("stroke", '#FF4142');
				lineEvel.setAttribute("stroke", '#272A34');
				isAnimEnd = true
				changeLineAndCircle(line, circle, "#626BF7", "2");
				groups.forEach(g => g.querySelector(".movingCircle")?.classList.remove("active-dot"));
				circle.classList.add("active-dot");

				const cx = parseFloat(circle.getAttribute("cx"));
				const cy = parseFloat(circle.getAttribute("cy"));
				moveTo(findClosestLength(cx, cy));

				// Show tooltip
				const text = group.dataset.text;
				updateTooltip(text, line, circle, group);
			});

			group.addEventListener("mouseleave", () => {
				line.setAttribute("stroke", line.dataset.prevStroke);
				line.setAttribute("stroke-width", line.dataset.prevStrokeWidth);

				circle.classList.remove("active-dot");
				hideTooltip();
			});
		});


		if (firstEl) {
			const circle = firstEl.querySelector(".movingCircle");
			changeLineAndCircle(lineFirst, circle, "#626BF7", "2");

			const text = firstEl.dataset.text;
			updateTooltip(text, lineFirst, circle, firstEl);


			if (isAnimEnd) return
			setTimeout(() => {
				changeLineAndCircle(lineFirst, circle, "#FF4142", "2");
				circle.classList.remove('active-dot');
				hideTooltip();

				if (isAnimEnd) return

				gsap.to(state, {
					progress: centerLength,
					duration: 3,
					ease: "power1.inOut",
					onUpdate: () => updateG(state.progress),
					onComplete: () => {
						if (isAnimEnd) return
						const circle = elevEl.querySelector(".movingCircle");
						handleLineAnimation(lineEvel, circle, text, firstEl, totalLength);
					}
				});
			}, 2000);
		}

	};
	const animSvgLeverageMob = () => {
		const mobSvgs = document.querySelectorAll(".leverage-home__mob");

		mobSvgs.forEach((svgElement) => {
			const path = svgElement.querySelector(".motionPathMob");
			const g = svgElement.querySelector(".movingGroupMob");
			const tooltip = document.querySelector(".leverage-home__tooltip");
			const tooltipText = tooltip?.querySelector(".leverage-home__tooltip-content");
			const tooltipClose = tooltip?.querySelector(".leverage-home__tooltip-close");
			const groups = svgElement.querySelectorAll(".line-svg");

			if (!path || !g || groups.length === 0) {
				// console.error("SVG элементы не найдены в одном из контейнеров");
				return;
			}

			const totalLength = path.getTotalLength();
			const offset = {x: 35, y: 52};
			const state = {progress: 0};

			// заранее считаем точки
			const pathPoints = [];
			for (let i = 0; i <= totalLength; i += 5) {
				pathPoints.push(path.getPointAtLength(i));
			}

			const findClosestPoint = (x, y) => {
				let best = 0, minDist = Infinity;
				pathPoints.forEach((pt, idx) => {
					const d = (pt.x - x) ** 2 + (pt.y - y) ** 2;
					if (d < minDist) {
						minDist = d;
						best = idx * 5;
					}
				});
				return best;
			};

			const updateG = (pos) => {
				const clamped = Math.min(Math.max(pos, 0), totalLength);
				const pt = path.getPointAtLength(clamped);
				g.setAttribute("transform", `translate(${pt.x - offset.x}, ${pt.y - offset.y})`);
				state.progress = clamped;
			};

			let currentTween = gsap.to(state, {
				progress: totalLength,
				duration: 3,
				ease: "power1.inOut",
				onUpdate: () => updateG(state.progress)
			});

			const moveTo = (target) => {
				if (currentTween) currentTween.kill();
				currentTween = gsap.to(state, {
					progress: target,
					duration: 1,
					ease: "power1.inOut",
					onUpdate: () => updateG(state.progress)
				});
			};

			// клики по точкам
			groups.forEach((group) => {
				const el = group.querySelector(".movingCircle");
				if (!el) return;

				group.addEventListener("click", (e) => {
					e.stopPropagation();
					e.preventDefault()
					groups.forEach((g) => g.classList.remove("active-dot"));
					group.classList.add("active-dot");

					const [tx, ty] = (group.dataset.transform || "0,0").split(",").map(Number);
					const cx = (el.tagName === "circle" ? parseFloat(el.getAttribute("cx")) : parseFloat(el.getAttribute("x"))) + tx;
					const cy = (el.tagName === "circle" ? parseFloat(el.getAttribute("cy")) : parseFloat(el.getAttribute("y"))) + ty;

					const closest = findClosestPoint(cx, cy);
					moveTo(closest);

					const tooltipTextContent = group?.dataset.text || "";
					if (tooltip && tooltipTextContent) {
						document.body.classList.add('no-scroll');
						document.documentElement.classList.add('no-scroll');
						tooltipText.innerHTML = tooltipTextContent;
						svgElement.classList.add("active");

						const rect = svgElement.getBoundingClientRect();
						const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
						const targetScroll = scrollTop + rect.top - window.innerHeight / 2 + rect.height / 2;
						scrollToDuration(targetScroll, 200, () => {
							const newRect = svgElement.getBoundingClientRect();
							tooltip.style.left = `${newRect.left + newRect.width / 2 - tooltip.offsetWidth / 2}px`;
							tooltip.style.top = `${newRect.top + newRect.height / 2 - tooltip.offsetHeight / 2}px`;
							tooltip.classList.add("active");
						});
					}
				});
			});

			// закрытие тултипа
			const closeTooltip = () => {
				tooltip?.classList.remove("active");
				svgElement.classList.remove("active");
				document.body.classList.remove('no-scroll');
				document.documentElement.classList.remove('no-scroll');
			};
			tooltipClose?.addEventListener("click", closeTooltip);
			window.addEventListener("resize", closeTooltip);
		});
	};

	const animLeverageOnScroll = () => {

		ScrollTrigger.create({
			trigger: ".leverage-home__svg",
			start: "top 30%",
			once: true,
			onEnter: () => {
				animSvgLeverage()
			}
		});

		ScrollTrigger.create({
			trigger: ".leverage-home__svg",
			start: "top 90%",
			once: true,
			onEnter: () => {
				animSvgLeverageMob();
			}
		});
	};

	const smoothScrollTo = (targetY) => {
		const startY = window.scrollY;
		const distance = targetY - startY;
		const duration = Math.min(1500, Math.max(500, Math.abs(distance) * 0.5));

		let startTime = null;

		function step(currentTime) {
			if (!startTime) startTime = currentTime;
			const timeElapsed = currentTime - startTime;
			const progress = Math.min(timeElapsed / duration, 1);

			const ease = progress < 0.5
				? 2 * progress * progress
				: -1 + (4 - 2 * progress) * progress;

			window.scrollTo(0, startY + distance * ease);

			if (timeElapsed < duration) {
				requestAnimationFrame(step);
			}
		}

		requestAnimationFrame(step);
	};

	const initSmoothScrollTarget = () => {
		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				const targetId = this.getAttribute('href');
				if (targetId && targetId.length > 1) {
					const targetElement = document.querySelector(targetId);

					if (targetElement) {
						e.preventDefault();
						const targetPosition = (targetElement.getBoundingClientRect().top + window.scrollY) - 40;

						smoothScrollTo(targetPosition);
					}
				}

			});
		});
	};


	// UNITY

	const loadHowVideo = () => {
		const blocks = document.querySelectorAll(".how-block__video, .contact-block__video");

		if (!blocks.length) return;

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const video = entry.target.querySelector("video");
					if (video && video.dataset.src) {
						video.src = video.dataset.src;
						video.load();
					}
					video?.pause();
					obs.unobserve(entry.target);
				}
			});
		}, {threshold: 0.5});

		blocks.forEach(block => {
			const video = block.querySelector("video");
			const playBtn = block.querySelector(".how-block__play , .contact-block__play");
			if (!video || !playBtn) return;

			observer.observe(block);

			playBtn.addEventListener("click", () => {
				video.play();
				playBtn.style.display = "none";
				video.setAttribute("controls", "controls");
			});

			video.addEventListener("pause", () => {
				if (!/Android/i.test(navigator.userAgent)) {
					playBtn.style.display = "block";
				}
			});

			video.addEventListener("play", () => {
				playBtn.style.display = "none";
			});
		});
	};

	// Contact page (unitysync tab) video play
	const loadUnityVideo = () => {
		const blocks = document.querySelectorAll(".video-playlist");
		if (!blocks.length) return;
	  
		blocks.forEach(block => {
			const overlay = block.querySelector(".video-overlay");
		  const video = block.querySelector("video");
		  const playBtn = block.querySelector(".contact-block__play");
		  if (!video || !playBtn || !overlay) return;
	  
		  // INIT STATE
		  playBtn.style.display = "none"; // hide SVG initially
		 

		  let playlist;
		  try {
			playlist = JSON.parse(video.dataset.playlist || "[]");
		  } catch {
			return;
		  }
		  if (!playlist.length) return;
	  
		  let index = 0;
		  let userPaused = false;
	  
		  // ---- helpers ----
		  const safePlay = () => {
			const p = video.play();
			if (p?.catch) p.catch(() => {});
		  };
		  // ------------------
	  
		  
	  
		  // preload & autoplay first video
		  video.src = playlist[0];
		  video.addEventListener(
			"canplay",
			() => {
			  if (!userPaused) safePlay();
			},
			{ once: true }
		  );
	  
		  // USER interaction
		  overlay.addEventListener("click", () => {
			if (video.paused) {
			  userPaused = false;
			  playBtn.style.display = "none";
			  safePlay();
			} else {
			  userPaused = true;
			  video.pause();
			  playBtn.style.display = "block"; // show SVG ONLY on user pause
			}
		  });
	  
		  playBtn.addEventListener("click", e => {
			e.preventDefault();
  			e.stopPropagation();

			userPaused = false;
			playBtn.style.display = "none";
			safePlay();
		  });
	  
		  // Endless playlist (no SVG interference)
		  video.addEventListener("ended", () => {
			index = (index + 1) % playlist.length;
	  
			// IMPORTANT: do NOT touch playBtn here
			video.src = playlist[index];
			video.load();
	  
			video.addEventListener("canplay", () => {
				if (!userPaused) safePlay();
			}, { once: true });
		  });
		});
	  };
	  
	  
	  
	  
	  
	  
	  
	  
	  

	// innerPages
	const initAboutBlockAnimation = () => {
		let mm = gsap.matchMedia();

		const intro = document.querySelector('.intro-anim');
		const about = document.querySelector('.about-anim');
		const aboutImage = document.querySelector('.about-anim-img img');
		const aboutTrigger = document.querySelector('.about-anim-img');

		if (!intro || !about) return;

		const startBottom = intro.classList.contains('min-100')
		mm.add("(min-width: 1024px)", () => {
			if (aboutImage) {
				gsap.to(aboutImage, {
					yPercent: -10,
					scale: 1.2,
					ease: "none",
					scrollTrigger: {
						trigger: aboutTrigger,
						start: "bottom bottom",
						end: "top top",
						scrub: true
					}
				});
			}


			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: intro,
					start: !startBottom ? 'top top' : 'bottom bottom',
					scrub: true,
					pin: true,
					pinSpacing: false,
					anticipatePin: 1
				}
			});

			tl.to(about, {
				y: 0,
				ease: "none"
			});

			return () => {
				tl.scrollTrigger?.kill();
				tl.kill();
			};
		});
	};

	function animateUnitySpectrum() {
		const wrapper = document.querySelector(".unity-spectrum__wrapper");
		const leftCols = document.querySelectorAll(".unity-spectrum__left .unity-spectrum__col");
		const rightItems = document.querySelectorAll(".unity-spectrum__right .unity-spectrum__element");

		if (!wrapper || leftCols.length === 0 || rightItems.length === 0) return;

		const mm = gsap.matchMedia();

		mm.add("(min-width: 1200px)", () => {
			// стартуем первое видео сразу при скролле к wrapper
			const firstVideo = rightItems[0].querySelector("video,img");
			if (firstVideo) {
				ScrollTrigger.create({
					trigger: wrapper,
					start: "top 80%",
					onEnter: () => {
						if (!firstVideo.src && firstVideo.dataset.src) {
							firstVideo.src = firstVideo.dataset.src
							firstVideo.play();
							rightItems[0].classList.add("active");
						} else {
							rightItems[0].classList.add("active");

						}
					}
				})

				// фиксируем правый блок и меняем активный по середине колонки
				ScrollTrigger.create({
					trigger: wrapper,
					start: "top top+=150",
					end: () => "+=" + (document.querySelector(".unity-spectrum__left").scrollHeight - rightItems[0].offsetHeight),
					pin: ".unity-spectrum__right",
					pinSpacing: false,
					onUpdate: self => {
						let activeIndex = 0;

						leftCols.forEach((col, i) => {
							const top = col.getBoundingClientRect().top;
							const visibleHeight = window.innerHeight - top;
							if (visibleHeight >= col.offsetHeight * 0.3) {
								activeIndex = i;
							}
						});

						setActive(activeIndex);
					}
				});

				function setActive(index) {
					rightItems.forEach((item, i) => {
						const video = item.querySelector("video");
						if (i === index) {
							item.classList.add("active");

							if (video) {
								if (!video.src) video.src = video.dataset.src; // подставляем src при первом показе
								video.play();
							}
						} else {
							item.classList.remove("active");
							if (video) video.pause();
						}
					});
				}
			}
		})
		mm.add("(max-width: 1199px)", () => {
			const videos = document.querySelectorAll(".unity-spectrum__left video[data-src]");

			videos.forEach(video => {
				ScrollTrigger.create({
					trigger: video,
					start: "top bottom-=50",
					end: "bottom top",
					onEnter: () => {
						if (!video.src && video.dataset.src) {
							video.src = video.dataset.src;
						}
						video.play().catch(() => {
						});
					},
					onEnterBack: () => {
						if (!video.src && video.dataset.src) {
							video.src = video.dataset.src;
						}
						video.play().catch(() => {
						});
					},
					onLeave: () => video.pause(),
					onLeaveBack: () => video.pause()
				});
			});
		});

	}


	let mm = gsap.matchMedia();
	let workBlockTween, workBlockTween2;

	const createWorkBlockAnimation = () => {
		const container = document.querySelector(".work-block");
		const items = document.querySelector(".work-block__list");
		const lastItem = document.querySelector(".work-block__item:last-child");
		const img = document.querySelector(".work-block__img");

		if (!container || !items || !lastItem || !img) return;

		if (workBlockTween) {
			if (workBlockTween.scrollTrigger) workBlockTween.scrollTrigger.kill();
			workBlockTween.kill();
			workBlockTween = null;
		}

		if (workBlockTween2) {
			if (workBlockTween2.scrollTrigger) workBlockTween2.scrollTrigger.kill();
			workBlockTween2.kill();
			workBlockTween2 = null;
		}

		mm.revert();

		mm.add("(min-width: 1200px)", () => {
			const paddingBottom = parseFloat(getComputedStyle(container).paddingBottom) || 0;
			const scrollDistance = items.clientHeight;
			const visibleHeight = container.clientHeight;

			const dis = scrollDistance - visibleHeight + lastItem.offsetHeight + paddingBottom;
			const imgDis = scrollDistance - (lastItem.offsetHeight / 2) - (img.clientHeight / 2);

			workBlockTween = gsap.to(items, {
				y: -dis,
				ease: "none",
				scrollTrigger: {
					trigger: container,
					start: "top top",
					end: "+=" + dis,
					scrub: true,
					pin: true,
					invalidateOnRefresh: true
				}
			});

			workBlockTween2 = gsap.to(img, {
				y: imgDis,
				ease: "none",
				scrollTrigger: {
					trigger: container,
					start: "top top",
					end: "+=" + dis,
					scrub: true,
				}
			});
		});

		mm.add("(max-width: 1199px)", () => {
			const scrollDistance = items.clientHeight;
			const imgDis = scrollDistance - (lastItem.offsetHeight / 2) - (img.clientHeight / 2);

			workBlockTween2 = gsap.to(img, {
				y: imgDis,
				ease: "none",
				scrollTrigger: {
					trigger: container,
					start: "top top",
					end: "bottom 50%",
					scrub: true,
				}
			});
		});
	};

	let previousWidth = window.innerWidth;
	let previousDPR = window.devicePixelRatio;


	window.addEventListener("resize", () => {
		const currentWidth = window.innerWidth;
		const currentDPR = window.devicePixelRatio;
		if (currentWidth !== previousWidth && currentWidth >= 767) {
			clearTimeout(window._resizeTimeout);
			window._resizeTimeout = setTimeout(() => {
				previousWidth = currentWidth;
				createWorkBlockAnimation()
				ScrollTrigger.refresh();
			}, 150);
		}

		if (
			currentWidth < 767 &&
			currentDPR === previousDPR &&
			currentWidth !== previousWidth
		) {
			clearTimeout(window._resizeTimeout);
			window._resizeTimeout = setTimeout(() => {
				createWorkBlockAnimation()
				ScrollTrigger.refresh();
			}, 150);
		}
	});

	function initBlogLoadMore() {

		function renderBlogItem(item) {
			return `<a href="${item.link}" class="blog-block__item">
            <div class="blog-block__img">
              ${
				item.video_url
					? `<video src="${item.video_url}"  preload="metadata" poster="${item.thumbnail}" muted playsinline autoplay></video>`
					: `<img src="${item.thumbnail}" alt="${item.title}">`
			}
            </div>
            <div class="blog-block__data">
              <div class="blog-block__content">
                <div class="blog-block__name">${item.title}</div>
                <div class="blog-block__tags">
                  ${
				item.tags
					? item.tags.map(tag => `<div class="blog-block__tag">${tag}</div>`).join('')
					: ''
			}
                </div>
              </div>
              <div class="blog-block__link">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26 30L24.6 28.55L28.15 25H16V23H28.15L24.6 19.45L26 18L32 24L26 30Z" fill="#272A34"/>
                </svg>
              </div>
            </div>
          </a>`;
		}

		let page = 1;
		const loadMoreButton = document.querySelector('.blog-block__more');
		const container = document.querySelector('.blog-block__list');

		if (!loadMoreButton || !container) return;

		loadMoreButton.addEventListener('click', (e) => {
			if (loadMoreButton.classList.contains('disabled')) {
				return;
			}
			e.preventDefault();
			loadMoreButton.classList.add('disabled');
			page++;

			const formData = new FormData();
			formData.append('action', loadMoreButton.dataset.action);
			formData.append('page', page);

			fetch(window.STPL.ajax_url, {
				method: 'POST',
				body: formData
			})
				.then(res => res.json())
				.then(data => {
					loadMoreButton.classList.remove('disabled');

					if (data.items.length) {
						data.items.forEach(item => {
							container.insertAdjacentHTML('beforeend', renderBlogItem(item));
						});
					}
					if (!data.show_load_more) {
						loadMoreButton.style.display = 'none';
					}
				})
				.catch(err => {
					loadMoreButton.classList.remove('disabled');
					page--;
				});
		});

	}

	const startAboutBreakVideoOnScroll = () => {
		const section = document.querySelector('.about-break');
		const video = section?.querySelector('video');

		if (!video) return;

		gsap.registerPlugin(ScrollTrigger);

		ScrollTrigger.create({
			trigger: section,
			start: "top 80%",
			once: true,
			onEnter: () => {

				if (video.dataset.src) {
					video.src = video.dataset.src;
					video.removeAttribute('data-src');
				}
				video.play().catch(() => {
				});
			}
		});
	};


	const startAboutIndustriesAnims = () => {
		const container = document.querySelector(".about-industries__content");

		if (!container) return;

		const containerSpeed = container.getAttribute('data-speed');
		const slides = document.querySelectorAll(".about-industries__el");
		const images = document.querySelectorAll(".about-industries__left .about-industries__item");
		if (!slides.length || !images.length) return;

		let current = 0;
		let tl;
		let currentIsMobile = false;
		const mm = gsap.matchMedia();

		function runLine(index) {
			if (tl) tl.kill();

			slides.forEach((el, i) => {
				if (i !== index) {
					gsap.set(el.querySelector(".about-industries__line"), {scaleX: 0});
				}
			});

			const line = slides[index].querySelector(".about-industries__line");
			gsap.set(line, {scaleX: 0, transformOrigin: "left center"});

			tl = gsap.timeline({
				onComplete: () => {
					nextSlide();
				}
			});

			tl.to(line, {
				scaleX: 1,
				duration: containerSpeed,
				ease: "linear"
			});
		}

		function activateSlide(index, isMobile) {
			if (index === current && tl) return;
			current = index;

			slides.forEach((el, i) => {
				const content = el.querySelector(".about-industries__contentM");
				el.classList.toggle("active", i === index);

				if (isMobile) {
					if (i === index) {
						gsap.to(content, {
							maxHeight: content.scrollHeight,
							duration: 0.4,
							ease: "power2.out"
						});
					} else {
						gsap.to(content, {
							maxHeight: 0,
							duration: 0.3,
							ease: "power2.inOut"
						});
					}
				} else {
					gsap.set(content, {maxHeight: "none"});
				}
			});

			images.forEach((img, i) => img.classList.toggle("active", i === index));

			if (+containerSpeed !== 0) {
				runLine(index);
			}
		}

		function nextSlide() {
			const next = (current + 1) % slides.length;
			activateSlide(next, currentIsMobile);
		}

		slides.forEach((el, i) => {
			el.addEventListener("click", () => {
				if (i !== current) {
					activateSlide(i, currentIsMobile);
				}
			});
		});

		mm.add("(max-width: 1199px)", () => {
			currentIsMobile = true;

			slides.forEach((el, i) => {
				const content = el.querySelector(".about-industries__contentM");
				if (i === current) {
					gsap.set(content, {maxHeight: content.scrollHeight});
				} else {
					gsap.set(content, {maxHeight: 0});
				}
			});
		});

		mm.add("(min-width: 1200px)", () => {
			currentIsMobile = false;

			slides.forEach((el) => {
				const content = el.querySelector(".about-industries__contentM");
				gsap.set(content, {maxHeight: "none"});
			});
		});

		gsap.registerPlugin(ScrollTrigger);

		ScrollTrigger.create({
			trigger: container,
			start: window.innerWidth <= 1200 ? 'top 88%' : 'top 78%',
			once: true,
			onEnter: () => {
				activateSlide(current, currentIsMobile);
			}
		});
	};


	const initTOC = () => {
		const leftCol = document.querySelector(".left-sticky-js");
		const rightCol = document.querySelector(".gen-tags");
		if (!leftCol || !rightCol) return;

		const headings = [...rightCol.querySelectorAll("h1,h2,h3,h4,h5:not(.share)")];
		if (!headings.length) return;

		const links = headings.map(h => {
			const a = document.createElement("a");
			a.className = "privacy-block__item";
			a.textContent = h.textContent.trim();
			leftCol.appendChild(a);
			return a;
		});

		links.forEach((link, i) => {
			link.addEventListener("click", async (e) => {
				e.preventDefault();
				await gsap.to(window, {
					duration: 0.75,
					scrollTo: {y: headings[i], offsetY: 90},
					ease: "power2.out"
				});
			});
		});

		setActive(0)
		headings.forEach((h, i) => {
			ScrollTrigger.create({
				trigger: h,
				start: "top+=-100 top",
				end: () => `bottom top+=-100`,
				onEnter: () => setActive(i),
				onEnterBack: () => setActive(i),
			});
		});


		function setActive(index) {
			links.forEach((l, j) => l.classList.toggle("active", j === index));
		}

		gsap.from(leftCol, {opacity: 0, x: -20, duration: 0.5, ease: "power2.out"});
	};

	// Careers
	const initLeftSticky = () => {
		let mm = gsap.matchMedia();

		mm.add("(min-width: 1201px)", () => {
			const stickyLeft = document.querySelector('.left-sticky-js');
			const stickyWrapper = document.querySelector('.wrapper-sticky-js');

			if (!stickyLeft || !stickyWrapper) return;

			const stickyTrigger = gsap.to(stickyLeft, {
				scrollTrigger: {
					trigger: stickyWrapper,
					pin: stickyLeft,
					start: () => {
						const header = document.querySelector('.header');

						return `top top+=${header.offsetHeight}`
					},
					end: () => {
						const wrapper = document.querySelector('.wrapper-sticky-js');
						const leftElement = document.querySelector('.left-sticky-js');
						const elHeight = wrapper.offsetHeight - leftElement.offsetHeight;
						return `+=${elHeight}`;
					},
					scrub: 1,
					anticipatePin: 1,
				}
			});

			return () => {
				stickyTrigger?.scrollTrigger?.kill();
				stickyTrigger?.kill();
			};
		});

	}

	const initCareersFilterItems = () => {
		const filters = document.querySelectorAll('.careers-block__filter');
		const items = document.querySelectorAll('.careers-block__item');

		filters.forEach(filter => {
			filter.addEventListener('click', () => {
				// переключаем активный фильтр
				filters.forEach(f => f.classList.remove('active'));
				filter.classList.add('active');

				const category = filter.dataset.filter;

				items.forEach(item => {
					if (category === 'all') {
						item.classList.remove('hidden');
					} else {
						const itemCategories = (item.dataset.filter || "")
							.split(',')
							.map(c => c.trim());

						item.classList.toggle(
							'hidden',
							!itemCategories.includes(category)
						);
					}
				});

				ScrollTrigger.refresh();
			});
		});
	};

	const footerAttachFile = () => {
		const block = document.querySelector('.footer__file');

		block?.querySelector('.file-input')?.addEventListener('change', e => {
			const file = e.target?.files?.[0];
			if (!file) return;

			block.querySelector('.file-btn').textContent = file.name;
			block.querySelector('svg').style.display = 'none';
			block.querySelector('.file-sizes').style.display = 'none';
		});
	}

	const initContactTabs = () => {
		try {
			var unitySyncSection = false;
			const tabs = document.querySelectorAll('.contact-block__tab');
			const lefts = document.querySelectorAll('.contact-block__el');
			const rights = document.querySelectorAll('.contact-block__item');

			if (!tabs.length) return;

			const params = new URLSearchParams(window.location.search);
			const urlTab = params.get('tab');
			let activeIndex = 0;

			if (urlTab) {
				const found = Array.from(tabs).findIndex(tab =>
					tab.dataset.name === urlTab
				);
				if (found !== -1) activeIndex = found;
			}

			const setActive = (i) => {
				tabs.forEach(t => t.classList.remove('active'));
				lefts.forEach(l => l.classList.remove('active'));
				rights.forEach(r => r.classList.remove('active'));

				if (tabs[i]) tabs[i].classList.add('active');
				if (lefts[i]) lefts[i].classList.add('active');
				if (rights[i]) rights[i].classList.add('active');

				const video = rights[i]?.querySelector('video');
				if(video && !unitySyncSection) {
					unitySyncSection = true;
					loadUnityVideo();
				}
			};

			setActive(activeIndex);

			tabs.forEach((tab, i) => {
				tab.addEventListener('click', () => {
					try {
						setActive(i);
						hideSubmitBlock()
						const name = tab.dataset.name || i;
						const newUrl = new URL(window.location);
						newUrl.searchParams.set('tab', name);
						history.replaceState(null, '', newUrl);
						ScrollTrigger.refresh();
					} catch (innerErr) {
						console.error(innerErr);
					}
				});
			});

		} catch (err) {
			console.error(err);
		}
	};

	const copyHandler = () => {
		document.querySelectorAll('.copy-url').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				navigator.clipboard.writeText(window.location.href)
				alert('Link copied')
			});
		});
	};

	const closePopup = () => {
		const closeButton = document.querySelectorAll('.popup-main__close')

		closeButton?.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const popup = el.closest('.popup-main')
				popup.classList.remove('active')
				setTimeout(() => {
					popup.classList.remove('success')
				}, 350)
				document.body.classList.remove('no-scroll')
			});
		});


	}

	const openScalePopup = () => {
		document.querySelectorAll('.btn-scale-popup').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const popup = document.querySelector('.popup-main')
				popup.classList.add('active')
				document.body.classList.add('no-scroll')
			});
		})
	}
	animateHeader()
	initHeroHomeAnimation()
	animateFirstAboutHomeItemOnly()
	initAboutHomeAnimationOnScroll();
	animateHeaderMenu()
	initLogoAnimation()
	initFaqAnimation()
	initSmoothScrollTarget()
	animLeverageOnScroll();
	initSplineWithFallback('.intro-home__spline');
	initSplineWithFallback('.numbers-home__canvas');
	initSpline('.not-found__spline');
	loadHowVideo()
	initAboutBlockAnimation()
	//animateUnitySpectrum()
	createWorkBlockAnimation();
	initBlogLoadMore()
	startAboutBreakVideoOnScroll()
	startAboutIndustriesAnims()
	initTOC()
	initLeftSticky()
	initCareersFilterItems()
	footerAttachFile()
	copyHandler()
	initContactTabs()
	closePopup()
	openScalePopup()
	hidePopupOutsideClickMain()
})
// $(document).ready(function () {
//
// })

